import amplitude from 'amplitude-js';

import { StorageKeys } from '@constants/common';
import UserAuth from '@services/auth';
import { getPageName } from './common';

export const setAmplitudeUserProperties = (id: string): void => {
  amplitude.getInstance().setUserId(id);
};

export const initAmplitude = (): void => {
  const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_KEY;

  if (amplitudeApiKey) amplitude.getInstance().init(amplitudeApiKey);
};

export const sendAmplitudeData = (
  eventName: string,
  eventProperties: any = {}
): void => {
  const userDetails = UserAuth.userDetails;

  amplitude.getInstance().logEvent(eventName, {
    'Page Name': eventProperties['Page Name']
      ? eventProperties['Page Name']
      : getPageName(),
    Navigation: eventProperties['Navigation']
      ? eventProperties['Navigation']
      : getPageName(
          window.localStorage.getItem(StorageKeys.PREVIOUS_URL) || ''
        ),
    ...(userDetails?.user?.id && {
      'User ID': userDetails?.user.id,
      Industry: userDetails?.industry,
      Role: userDetails?.role,
      Company: userDetails?.company_name,
      current_plan: `${userDetails?.plan} ${
        userDetails?.is_trial ? '_TRIAL' : ''
      }`
    }),
    ...eventProperties
  });
};
